import React from 'react';
import { Lock, RotateCcw, Zap } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative overflow-hidden min-h-[600px] md:min-h-[680px] flex items-center" data-id="element-195">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/gkkCpkyHMUK3hmFWjSWZ1g/ajWmPRNeeS8eaMBjDFKfK-min.png" alt="" className="absolute inset-0 w-full h-full object-cover object-right-top pointer-events-none select-none" data-id="element-196" />

      {/* Dark gradient overlay — keeps text readable on the left, lets the man show on the right */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(0,0,0,.92)_0%,rgba(0,0,0,.78)_35%,rgba(0,0,0,.35)_65%,rgba(0,0,0,.15)_100%)]" data-id="element-197" />

      {/* Extra top/bottom vignette for polish */}
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,.5)_0%,transparent_25%,transparent_75%,rgba(0,0,0,.6)_100%)]" data-id="element-198" />

      <div className="container relative z-10 py-16 md:py-24" data-id="element-199">
        <div className="max-w-[540px]" data-id="element-200">
          <div className="inline-flex items-center gap-2.5 bg-[rgba(201,151,43,.15)] border border-[rgba(201,151,43,.35)] rounded-full py-1.5 px-4 text-[11px] tracking-[.15em] uppercase text-dorado-claro mb-5 backdrop-blur-sm" data-id="element-201">
            <div className="w-1.5 h-1.5 bg-dorado rounded-full animate-blink" data-id="element-202" />
            Psicología Oscura Aplicada
          </div>

          <h1 className="font-playfair font-black leading-[1.1] mb-5" data-id="element-203">
            <span className="block text-[clamp(1.5rem,2.8vw,2.3rem)] text-crema-oscuro" data-id="element-204">
              Domina el Arte de
            </span>
            <span className="block text-[clamp(2.2rem,5vw,4rem)] italic text-dorado-claro" data-id="element-205">
              Influir, Persuadir
            </span>
            <span className="block text-[clamp(1.5rem,2.8vw,2.3rem)] text-crema-oscuro" data-id="element-206">
              y Protegerte.
            </span>
          </h1>

          <p className="text-[0.92rem] text-[#c0c0c0] leading-[1.8] mb-7 max-w-[440px]" data-id="element-207">
            Descubre los principios de la psicología oscura que los líderes,
            negociadores y comunicadores élite usan cada día — y cómo blindarte
            cuando otros los usan contigo.
          </p>

          <a href="#oferta" className="btn-primary animate-shimmer inline-flex items-center justify-center whitespace-nowrap flex-nowrap gap-2" data-id="element-208">
            
            <span data-id="element-209">Quiero acceder ahora</span>
          </a>

          <div className="flex flex-wrap gap-3.5 text-xs text-[#999] mt-6" data-id="element-210">
            <span className="flex items-center gap-1.5" data-id="element-211">
              <Lock className="w-3.5 h-3.5 text-dorado" data-id="element-212" /> Compra 100% segura
            </span>
            <span className="flex items-center gap-1.5" data-id="element-213">
              <RotateCcw className="w-3.5 h-3.5 text-dorado" data-id="element-214" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-215">
              <Zap className="w-3.5 h-3.5 text-dorado" data-id="element-216" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}